module.exports = __webpack_public_path__ + "img/logoHaNoi.60de1678.jpg";